import { getConfig, getErrorMessage, klinikenApi } from "@/api";
import { openDialog } from "@/utils";

const getDefaultState = () => {
    return {
        systemName: null,
        systemVersion: null,
        udiDi: null,
        kundNamn: "",
        authenticationMethods: [],
        SMSEnabled: false,
        fallbackSignMethod: null,
        ehmGlnReceptbrevladan: null,
        janusBaseURL: null,
        operationXMinuterKvar: 0,
        operationXMinuterKvarEndMarker: null,
        purConfigured: false,
        kivraConfigured: false,
        isTest: false,
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        systemName(state) {
            return state.systemName;
        },
        systemVersion(state) {
            return state.systemVersion;
        },
        udiDi(state) {
            return state.udiDi;
        },
        kundNamn(state) {
            return state.kundNamn;
        },
        authenticationMethods(state) {
            return state.authenticationMethods;
        },
        SMSEnabled(state) {
            return state.SMSEnabled;
        },
        fallbackSignMethod(state) {
            return state.fallbackSignMethod;
        },
        ehmGlnReceptbrevladan(state) {
            return state.ehmGlnReceptbrevladan;
        },
        janusBaseURL(state) {
            return state.janusBaseURL;
        },
        operationXMinuterKvar(state) {
            return state.operationXMinuterKvar;
        },
        operationXMinuterKvarEndMarker(state) {
            return state.operationXMinuterKvarEndMarker;
        },
        purConfigured(state) {
            return state.purConfigured;
        },
        kivraConfigured(state) {
            return state.kivraConfigured;
        },
        isTest(state){
          return state.isTest;
        },
    },
    mutations: {
        reset() {},
        load(state, data) {
            state.systemName = data.system_name;
            state.systemVersion = data.system_version;
            state.udiDi = data.udi_di;
            state.kundNamn = data.kundnamn;
            state.authenticationMethods = data.authentication_methods;
            state.SMSEnabled = data.sms_enabled;
            state.fallbackSignMethod = data.fallback_sign_method;
            state.ehmGlnReceptbrevladan = data.ehm_gln_receptbrevladan;
            state.janusBaseURL = data.janus_base_url;
            state.operationXMinuterKvar = data.operation_x_minuter_kvar;
            state.operationXMinuterKvarEndMarker = data.operation_x_minuter_kvar_end_marker;
            state.purConfigured = data.pur_configured;
            state.kivraConfigured = data.kivra_configured;
            state.isTest = data.is_test;
        },
    },
    actions: {
        async loadFromBackend({ commit }, failSilently = false) {
            const config = getConfig();
            return klinikenApi
                .get("systeminformation/", config)
                .then((response) => {
                    commit("load", response.data);
                })
                .catch((e) => {
                    if (!failSilently) {
                        openDialog("Kunde inte hämta systeminformation från servern." + getErrorMessage(e), "warning");
                    }
                });
        },
    },
};
